import { render, staticRenderFns } from "./calldetail.vue?vue&type=template&id=2ff8e4e7&scoped=true&"
import script from "./calldetail.vue?vue&type=script&lang=js&"
export * from "./calldetail.vue?vue&type=script&lang=js&"
import style0 from "./calldetail.vue?vue&type=style&index=0&id=2ff8e4e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8e4e7",
  null
  
)

export default component.exports